import styles from "./Sidebar.module.css";

const links = [
  { label: "Blog", href: "#/blog", section: "blog" },
  { label: "Projects", href: "#projects", section: "projects" },
  { label: "Work experience", href: "#work-experience", section: "work-experience" },
  { label: "Education", href: "#education", section: "education" },
];

const Sidebar = ({ route, onNavigate, theme, onToggleTheme }) => (
  <nav className={styles.sidebar} aria-label="Main navigation">
    <ul className={styles.links}>
      {links.map(({ label, href, section }) => {
        const active = section === "blog" ? route.page.startsWith("blog") : route.section === section;
        return (
          <li key={section}>
            <a
              href={href}
              aria-current={active ? (section === "blog" ? "page" : "location") : undefined}
              onClick={(event) => onNavigate(event, href)}
            >
              {label}
            </a>
          </li>
        );
      })}
    </ul>
    <button
      className={styles.themeButton}
      type="button"
      onClick={onToggleTheme}
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}
      title="Change theme. Automatic themes resume in the next section."
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
        {theme === "dark" ? (
          <>
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5m11 11L19 19M5 19l1.5-1.5m11-11L19 5" />
          </>
        ) : <path d="M20.5 14a8.5 8.5 0 0 1-10.5-10.5A8.5 8.5 0 1 0 20.5 14Z" />}
      </svg>
      <span>{theme === "dark" ? "Light theme" : "Dark theme"}</span>
    </button>
  </nav>
);

export default Sidebar;
